// extracted by mini-css-extract-plugin
export default {"modal-title":"SXuT8Aa_3yLU_iuv0U6a","left-field":"s8sKlZ60GoD_gqM9P5UF","right-field":"PKQymXwWrvfCoxcTM2ym","product-modify-modal":"SHw05sNhd7XH1J_NaAUy"};